<template>
    <div class="wheel-banner">
        <WebpImage :class="imageClass" :src="imageSrc" :alt="imageAlt" :get2x="!props.isCoin"></WebpImage>
        <div class="wheel-banner__content">
            <div class="wheel-banner__text" v-html="text"></div>
            <DsButton
                class="wheel-banner__button"
                :href="link"
                type="text"
                icon-right="arrow-right"
                size="sm"
                :event-name="isCoin ? 'openLinkBrowser' : undefined"
                :event-argument="isCoin ? link : undefined"
                :open-in-new-tab="isCoin ? true : undefined"
                @click="emit('clickButton')"
                >Více informací</DsButton
            >
        </div>
    </div>
</template>

<script lang="ts" setup>
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import { computed } from "vue";

const props = defineProps<{
    isCoin: boolean;
    text: string;
    link: string;
}>();

const emit = defineEmits(["clickButton"]);

const imageSrc = computed(() =>
    props.isCoin
        ? "/frontend/kasa-loyalty/img/widgets/wheel-campaign/Coin-with-shadow.png"
        : "/frontend/kasa-loyalty/img/homepage/obtainable-bonus.png"
);

const imageAlt = computed(() => (props.isCoin ? "zlatá mince" : "získejte bonus"));

const imageClass = computed(() => (props.isCoin ? "wheel-banner__coin" : "wheel-banner__bonus"));
</script>
